import SpritePoly from './spritePoly';
import * as Matter from 'matter-js';;
import { Polygon } from 'pixi.js';
import Position from './position';

/**
 * 
 */
export default class SpritePolyPhys extends SpritePoly {
	
	/**
	 * Matter.js physics body represented by a PIXI graphics object, supports concave polygons
	 * @param {Object} args
	 * @param {Position} args.position starting position before physics takes over
	 * @param {*} args.shape string or array of strings describing continuous lines of space-separated x y coords, eg. ['0 0 50 0 50 250 0 250','0 0 10 0 10 10 0 10']
	 * @param {Number} args.color rgb hex color eg. 0x00ff00
	 * @param {Number} args.lineWeight scale-independent line weight
	 * @param {Boolean} args.interactive whether the PIXI graphics object will respond to mouse/touch events
	 * @param {Boolean} args.skipEndPoint remove last pair of coords from path (physics object), for compatibility with imported SVG shapes
	 * @param {Boolean} args.isStatic Matter ...
	 * @param {Number} args.density Matter ...
	 * @param {Number} args.friction Matter ...
	 * @param {Number} args.restitution Matter ...
	 * @param {Number} args.angularVelocity Matter ...
	 */
	constructor(args) {
		super(args);
		this.initPaths = false; // generate paths from shape data on init
	}

	init(entity) {
		super.init(entity);

		let args = this._args;
		args.shape = args.shape[0]; // physics objects are defined only by their first path

		// Matter physics body from path
		if(args.skipEndPoint) {
			args.shape = args.shape.split(' ');
			args.shape.splice(args.shape.length-2, 2);
			args.shape = args.shape.join(' ');
		}
		this.body = Matter.Bodies.fromVertices(
			args.position.x,
			args.position.y,
			Matter.Vertices.fromPath(args.shape),
			{
				isStatic: args.isStatic || false,
				density: args.density || 0.5,
				friction: args.friction || 0.9,
				restitution: args.restitution || 0.3,
				// slop:5 // sticky objects
			},
			true
		);
		Matter.Body.scale(this.body, args.position.scale, args.position.scale);
		Matter.Body.rotate(this.body, args.position.rotation);
		if(args.angularVelocity) Matter.Body.setAngularVelocity(this.body, args.angularVelocity);
		Matter.Composite.add(this.scene.phys.world, this.body);

		// transforms not needed for Matter objects
		this.position.scale = 1;
		this.position.rotation = 0;
	}

	generateMatterPaths() {
		this.paths = [];
		let path = [];
		// extract vertices from Matter polygon for PIXI graphics object
		// handle multi-part concave bodies, don't draw internal edges
		let cx = this.body.position.x;
		let cy = this.body.position.y;
		for(let p = this.body.parts.length > 1 ? 1 : 0; p < this.body.parts.length; p++) {
			let part = this.body.parts[p];
			path = [];
			path.push([part.vertices[0].x-cx, part.vertices[0].y-cy]); // start
			for(let v = 1; v < part.vertices.length; v++) {
				if(!part.vertices[v-1].isInternal) {
					// draw to current, previous was not internal
					path.push([part.vertices[v].x-cx, part.vertices[v].y-cy]);
				} else {
					// pen-up to current, previous was internal
					this.paths.push(path);
					path = [];
					path.push([part.vertices[v].x-cx, part.vertices[v].y-cy]);
				}
				if(part.vertices[v].isInternal) {
					// pen-up to next (or wrap to first), this one is internal
					this.paths.push(path);
					path = [];
					path.push([part.vertices[(v+1)%part.vertices.length].x-cx, part.vertices[(v+1)%part.vertices.length].y-cy]);
				}
			}
			// draw back to start
			path.push([part.vertices[0].x-cx, part.vertices[0].y-cy]);
		}
		this.paths.push(path);
	}

	update(delta, deltaNormal) {
		this.generateMatterPaths();
		let cx = this.position.x = this.body.position.x;
		let cy = this.position.y = this.body.position.y;
		super.update(delta, deltaNormal);
		// copy simplified hit test polygon from Matter to PIXI, concave shapes are compromised
		let bounds = [];
		for(let v of this.body.vertices) {
			bounds.push(v.x-cx, v.y-cy);
		}
		this.g.hitArea = new Polygon(...bounds);
	}
	
}